"use strict";

var __extends = this && this.__extends || function () {
  var _extendStatics = function extendStatics(d, b) {
    _extendStatics = Object.setPrototypeOf || {
      __proto__: []
    } instanceof Array && function (d, b) {
      d.__proto__ = b;
    } || function (d, b) {
      for (var p in b) {
        if (b.hasOwnProperty(p)) d[p] = b[p];
      }
    };

    return _extendStatics(d, b);
  };

  return function (d, b) {
    _extendStatics(d, b);

    function __() {
      this.constructor = d;
    }

    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
  };
}();

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }

  return cooked;
};

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = __importStar(require("react"));

var react_native_1 = require("react-native");

var styled_components_1 = __importDefault(require("styled-components"));

var IFrameWeb =
/** @class */
function (_super) {
  __extends(IFrameWeb, _super);

  function IFrameWeb() {
    return _super !== null && _super.apply(this, arguments) || this;
  }

  IFrameWeb.prototype.render = function () {
    var _a = this.props,
        source = _a.source,
        height = _a.height;
    return react_1.default.createElement(Container, {
      height: height
    }, react_1.default.createElement("iframe", {
      src: source,
      style: frameStyles
    }));
  };

  return IFrameWeb;
}(react_1.PureComponent);

exports.IFrameWeb = IFrameWeb;
var frameStyles = {
  width: '100%',
  height: '100%',
  borderWidth: 0,
  borderColor: 'transparent'
};
var Container = styled_components_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    width: 100%;\n    height: ", ";\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n"], ["\n    width: 100%;\n    height: ", ";\n    overflow-y: scroll;\n    -webkit-overflow-scrolling: touch;\n"])), function (_a) {
  var height = _a.height;
  return height ? height : '100vh';
});
var templateObject_1;